export enum DocTypeSource {
  Broker = "broker",
  Company = "company",
  Doctor = "doctor",
  Employee = "employee",
  Supplier = "supplier",
}
